export const defaultIcons = [
    'ELEVATOR',
    'ENTRANCE',
    'ROOF_ACCESS',
    'ACCESSIBILITY',
    'WHEELCHAIR',
    'SIGN_LANGUAGE',
    'BUILDING_SIDE',
    'EQUIPMENT_ROOM',
    'GENERATOR_ROOM',
    'TRANSFORMER_ROOM',
    'BOILER_ROOM',
    'SPRINKLER_ROOM',
    'FIRE_ALARM',
    'FIRE_EXTINGUISHER',
    'FIRE_HOSE',
    'FIRE_LADDER',
    'FIRE_DOOR',
    'FIREFIGHTING_EQUIPMENT',
    'GENERATOR',
    'CONTROL_PANEL',
    'SMOKE_CONTROL',
    'TOXICITY',
    'BIOHAZARD',
    'CORROSION',
    'ELECTRICAL_HAZARD',
    'EXPLOSIVE',
    'FLAMMABLE',
    'HAZARDOUS_MATERIAL',
    'EMERGENCY_EXIT',
    'EMERGENCY_PHONE',
    'FIRST_AID',
    'LIFE_JACKET',
    'EVACUATION_POINT',
    'SAFETY_SHOWER',
    'SECURITY_CAMERA',
    'SECURITY_PANEL',
    'MOTION_DETECTOR',
    'SMOKE_DETECTOR',
    'SMART_LOCK',
    'GAS_VALVE',
    'WATER_VALVE',
    'ELECTRICAL_PANEL',
    'SPRINKLER_VALVE',
    'EXHAUST_FAN',
    'SMOKE_VENT',
    'CHIMNEY',
    'SPRINKLER_SYSTEM',
    'FIRE_PUMP',
    'HYDRANT',
    'HOSE_CABINET',
];
export const eventTypes = ['OFFER', 'EVENT', 'NEWS'];
